export const getUrlFromIframeSnippet = (iframeString) => {
  const regex = /<iframe[^>]*\s+src="([^"]+)"/;
  const match = iframeString.match(regex);
  if (match && match[1]) {
    return match[1];
  } else {
    return iframeString;
  }
};
